// audio amplitude maximiser / limiter
export const limitAmplitude = (amplitude, amplitudeMax = 1.8) => {
  const newAmplitude = 1 + amplitude * 3
  if (newAmplitude > amplitudeMax) {
    return amplitudeMax
  }
  return newAmplitude
}
